
import { IRoleAccess } from '../types';



export const policy: IRoleAccess = {
  sharedResource: {
    create: false,
    delete: false,
    update: false,
    view: false
  },
  superIntendent: {
    create: true,
    delete: true,
    update: true,
    view: true
  },
  admin: {
    create: true,
    delete: true,
    update: true,
    view: true
  },
  client: {
    create: true,
    delete: true,
    update: true,
    view: true
  },
  contractor: {
    create: true,
    delete: true,
    update: true,
    view: true
  },
  designer: {
    create: true,
    delete: true,
    update: true,
    view: true
  },
  staff: {
    create: true,
    delete: true,
    update: true,
    view: true
  }
};
